import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import InstallerTableComponent from '../Components/InstallerTableComponent.jsx';
import {
  installerTestsReducer,
  getScenariosByDispatcherId
} from '../reducers';
import { dispatcher as dispatcherSelectors } from '../selectors';

import {
  installerFiles as installerFileActions,
  modal as modalActions
} from '../actions';
import AcknowledgeTestsModalContainer from './AcknowledgeTestsModalContainer.jsx';
import {
  auth,
  installer as installerHelpers,
} from '../helpers';
import { USER_KEY } from '../helpers/storage';

const BUTTON_COL_STYLE = { textAlign: 'center' };
const BUTTON_STYLE = { float: 'right' };
const BUTTON_STYLE_DISABLED = {
  ...BUTTON_STYLE,
  pointerEvents: 'none'
};

export class InstallerTestExpectedContainer extends Component {
    static propTypes = {
      data: PropTypes.object.isRequired,
      fetchInstallerExpectedFiles: PropTypes.func.isRequired,
      scenarios: PropTypes.array,
      setExpected: PropTypes.func.isRequired,
      showExpected: PropTypes.bool,
      showTestsScenariosModal: PropTypes.func.isRequired,
      showAcknowledgeTestsModal: PropTypes.func.isRequired,
      requiresAck: PropTypes.bool.isRequired,
      isAuthenticated: PropTypes.bool.isRequired
    };

    constructor(props) {
      super(props);
      this.state = { expected: [] };
    }

    componentDidUpdate(prevProps) {
      if (
        this.props.scenarios &&
        this.props.scenarios.length > 0 &&
        this.props.scenarios !== prevProps.scenarios
      ) {

        const runners = this.props.scenarios.map(s => s.runner);

        this.props.fetchInstallerExpectedFiles(runners);
        this.setState({ expected: [] });
      }
    }

    toggleExpected = (filename, presenceId, expected) => {
      const currExpected = this.state.expected.slice();
      const expectedContains = currExpected.findIndex(expected => {
        return expected.filename === filename && expected.presenceId === presenceId;
      });
      if (expectedContains !== -1)
      {
        currExpected.splice(expectedContains, 1);
      }
      else {
        currExpected.push({ filename, presenceId, expected });
      }
      this.setState({ expected: currExpected });
    }

    sortByPresence = (a, b) => {
      a = a.toUpperCase();
      b = b.toUpperCase();
      const presenceA = a.substr(a.lastIndexOf('_') + 1);
      const presenceB = b.substr(b.lastIndexOf('_') + 1);

      // Sort by presence. If same presence, sort alphabetically
      if (presenceA > presenceB)
        return -1;
      else if (presenceA < presenceB)
        return 1;
      else if (a < b)
        return -1;
      else
        return 1;
    }

    constructTableRows = ({ data, showTestsScenariosModal }) => {
      const tableRows = [];
      if (Object.keys(data).length > 0) {
        const numScenarios = this.props.scenarios ?
          this.props.scenarios : 0;

        Object.keys(data).sort(this.sortByPresence).forEach(scenarioName => {
          const installerResult = data[scenarioName];

          const index = scenarioName.lastIndexOf('_');
          const filename = scenarioName.substr(0, index);
          const expected = installerResult.Expected;
          const runners = installerResult.Runners;

          // do not show expected for presence types of 'Missing from Pre-Update Delta Pack' or 'Missing from Post-Update Delta Pack'
          // these indicate back packs, hence bad builds, and should not be acknowledged as expected
          const disableAck = installerResult.Presence === installerHelpers.MISSING_PREPACK_PRESENCE ||
            installerResult.Presence === installerHelpers.MISSING_POSTPACK_PRESENCE;
          const showExpected = this.props.showExpected || false;

          if (Boolean(expected) === showExpected)
            tableRows.push(
              <tr
                key={scenarioName}
                className={`${filename ? 'active' : ''}`}
              >
                <td>{filename}</td>
                <td>{installerResult.Presence}</td>
                { !showExpected ?
                  (runners.length === numScenarios.length ?
                    <td style={BUTTON_COL_STYLE}>All</td> :
                    <td style={BUTTON_COL_STYLE}>
                      <Button id={scenarioName}
                        onClick={() => {
                          showTestsScenariosModal(runners);
                          document.activeElement.blur();
                        }}
                      >Show Scenarios</Button>
                    </td>) :
                  null
                }
                {showExpected ? <td>{installerResult.Username}</td> : null}
                <td style={BUTTON_COL_STYLE}>
                  <input type="checkbox"
                    id={'button-' + scenarioName}
                    title={disableAck ? 'Acknowledgement disabled for this presence type' : ''}
                    disabled={disableAck}
                    onClick={() =>
                      this.toggleExpected(
                        filename, installerResult.PresenceId, expected ^ 1
                      )}
                  />
                </td>
              </tr>
            );
        });
      }

      else {
        tableRows.push(
          <tr key={'Empty'}><td>No changes found</td></tr>
        );
      }
      return tableRows;
    }

    render() {
      const modalPresent = requiresAck => {
        if (requiresAck) {
          return (
            <AcknowledgeTestsModalContainer
              expected={this.state.expected}
              submitCallback={() => this.setState({ expected: [] })}
            />
          );
        }
      };

      const submitButton = () => {
        return (
          <Button id="submit-button"
            variant="warning"
            style={this.props.isAuthenticated ? BUTTON_STYLE : BUTTON_STYLE_DISABLED}
            disabled={!this.props.isAuthenticated}
            onClick={this.props.requiresAck ?
              this.props.showAcknowledgeTestsModal :
              () => {
                this.props.setExpected(this.state.expected);
                this.setState({ expected: [] });
              }
            }
          >
            {this.props.showExpected ? 'Remove Acknowledgements' :
              'Submit Acknowledgements'}
          </Button>
        );
      };

      const authenticatedSubmitButton = () => {
        return this.props.isAuthenticated ? (
          <div>
            {submitButton()}
          </div>
        ) : (
          <div>
            <OverlayTrigger
              overlay={
                <Popover
                  id="missing-authentication-popover"
                  title="Missing Authentication"
                >
                  Please log in with your Jira credentials to make changes
                </Popover>
              }
            >
              <div style={{ float: 'right' }}>
                {submitButton()}
              </div>
            </OverlayTrigger>
          </div>
        );
      };

      return (
        <div>
          <InstallerTableComponent
            tableRows={this.constructTableRows(this.props)}
            secondColumnName={'Presence'}
            thirdColumnName={!this.props.showExpected ? 'Scenarios' : null}
            fourthColumnName={this.props.showExpected ? 'Acknowledged By' : null}
            acknowledgeColumn={this.props.showExpected ?
              'Disacknowledge?' : 'Acknowledge?'}
            {...this.props}
          />
          {authenticatedSubmitButton()}
          {modalPresent(this.props.requiresAck)}
        </div>
      );
    }
}

export const mapStateToProps = (state) => {
  const dispatcherInfo = dispatcherSelectors.getDispatcherJobInfo(state);
  const scenarios = dispatcherInfo.dispatcherId ?
    getScenariosByDispatcherId(state, dispatcherInfo.dispatcherId) : [];
  const data = installerTestsReducer.getinstallerTestExpected(state);
  return {
    data: data,
    scenarios: scenarios,
    isAuthenticated: auth.checkAuthenticated()
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    setExpected: (results) =>
      results.forEach(result => {
        dispatch(installerFileActions.setInstallerExpectedFile(
          result.filename, result.presenceId, result.expected,
          localStorage.getItem(USER_KEY) || ''));
      }),
    fetchInstallerExpectedFiles: jobIds =>
      dispatch(installerFileActions.fetchInstallerExpectedFiles(jobIds)),
    showTestsScenariosModal: (runners) =>
      dispatch(modalActions.showTestsScenariosModal(true, runners)),
    showAcknowledgeTestsModal: () =>
      dispatch(modalActions.showAcknowledgeTestsModal(true)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InstallerTestExpectedContainer);


// WEBPACK FOOTER //
// src/Containers/InstallerTestExpectedContainer.jsx